module.exports = __webpack_public_path__ + "static/media/vuesax-logo.cd1dcfa9.png";